module.exports = __webpack_public_path__ + "octoclippy.44018a09d44acd7e57d064cebbd76cf2.hashedasset.svg";